<template>
  <div
    class="task-detail-reason-menu"
    :data-testid="dataTestid"
  >
    <div class="task-detail-reason-menu__body">
      <h6 class="task-detail-reason-menu__title">{{ title }}</h6>

      <div class="task-detail-reason-menu__field">
        <label
          class="task-detail-reason-menu__label"
          :class="{ 'task-detail-reason-menu__label--error': showErrorState }"
          :for="textareaId"
        >
          {{ remarksLabel }}
        </label>
        <div
          class="task-detail-reason-menu__textarea-wrap"
        >
          <textarea
            :id="textareaId"
            class="task-detail-reason-menu__textarea"
            :value="value"
            :placeholder="placeholder"
            rows="4"
            :data-testid="reasonInputTestid"
            @input="$emit('input', $event.target.value)"
          />
          <img
            src="/img/icons/fbc-icons/TextareaResizeGrip.svg"
            alt=""
            class="task-detail-reason-menu__resize-grip"
            width="7.33423"
            height="7.33422"
          />
        </div>
      </div>
    </div>

    <div class="task-detail-reason-menu__footer">
      <button
        type="button"
        class="task-detail-reason-menu__confirm"
        :class="{ 'task-detail-reason-menu__confirm--disabled': isConfirmDisabled }"
        :disabled="isConfirmDisabled"
        :data-testid="confirmTestid"
        @click="$emit('confirm')"
      >
        {{ confirmLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { TASK_DETAIL_REASON_MENU } from '@/modules/financialclose/utils/constants';

let textareaUid = 0;

export default {
  name: 'TaskDetailReasonMenu',

  props: {
    title: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    remarksRequired: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    confirmLabel: {
      type: String,
      default: TASK_DETAIL_REASON_MENU.CONFIRM_LABEL,
    },
    dataTestid: {
      type: String,
      default: 'task-detail-reason-menu',
    },
    reasonInputTestid: {
      type: String,
      default: 'task-detail-reason-menu__reason-input',
    },
    confirmTestid: {
      type: String,
      default: 'task-detail-reason-menu__confirm-btn',
    },
  },

  data() {
    textareaUid += 1;
    return {
      textareaId: `task-detail-reason-menu__textarea-${textareaUid}`,
    };
  },

  computed: {
    trimmedValue() {
      return (this.value || '').trim();
    },

    remarksLabel() {
      return this.remarksRequired
        ? TASK_DETAIL_REASON_MENU.REMARKS_REQUIRED_LABEL
        : TASK_DETAIL_REASON_MENU.REMARKS_LABEL;
    },

    showErrorState() {
      return this.remarksRequired && !this.trimmedValue;
    },

    isConfirmDisabled() {
      return this.remarksRequired && !this.trimmedValue;
    },
  },
};
</script>

<style lang="scss">
@import './TaskDetailReasonMenu.scss';
</style>
